import instance8001 from '../axios/http.ts'
// import instance from '../axios/index.ts'
/** 登录求情 */
export function loginRequest(data: any): Promise<any> {
  return instance8001.post('/api/login_request', data)
}
/** 登录响应 */
export function loginResponse(data: any): Promise<any> {
  return instance8001.post('/api/login_response', data)
}
/** 获取子机状态 */
export function getSubsysStatus(data: any): Promise<any> {
  return instance8001.post('/api/get_subsys_status', data)
}
